import { createContext, type ReactNode, useContext } from "react"
import { type RootStore, rootStore } from "./RootStore"

const StoreContext = createContext<RootStore>(rootStore)

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
}

export const useStore = () => {
  const context = useContext(StoreContext)
  if (!context) {
    throw new Error("useStore must be used within StoreProvider")
  }
  return context
}

export const useAuthStore = () => useStore().auth
export const useThemeStore = () => useStore().theme
export const useI18nStore = () => useStore().i18n
export const useRouterStore = () => useStore().router
export const useDataStore = () => useStore().data
export const useMetadataStore = () => useStore().metadata
export const useViewStore = () => useStore().view
export const useDoraMetricsStore = () => useStore().doraMetrics
export const useSettingsStore = () => useStore().settings
export const useCustomDashboardStore = () => useStore().customDashboard
